(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["broker-package"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tabs = document.querySelectorAll('.broker-tab');
    const cards = document.querySelectorAll('.broker-card');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = 'broker-card-' + tab.dataset.brokerTab;

        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.classList.toggle('bg-dark', active);
          t.classList.toggle('border-dark', active);
          t.classList.toggle('text-white', active);
          t.classList.toggle('bg-transparent', !active);
          t.classList.toggle('border-[rgba(17,16,16,0.11)]', !active);
          t.classList.toggle('text-[#9a9088]', !active);
        });

        cards.forEach((card) => {
          const show = card.id === targetId;
          card.classList.toggle('hidden', !show);
          card.classList.toggle('flex', show);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cart-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.cartQtyChange;
        const delta = parseInt(btn.dataset.delta, 10);
        const input = document.querySelector('[data-cart-qty-input="' + key + '"]');
        if (!input) return;
        const newVal = Math.max(0, parseInt(input.value, 10) + delta);
        input.value = newVal;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Mobile menu toggle
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = document.getElementById('mobile-nav');
    const overlay = document.querySelector('[data-menu-overlay]');
    if (toggle && nav && overlay) {
      const openMenu = () => {
        toggle.setAttribute('aria-expanded', 'true');
        nav.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        overlay.classList.add('is-open');
        nav.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
      };

      const closeMenu = () => {
        toggle.setAttribute('aria-expanded', 'false');
        nav.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.classList.remove('is-open');
        nav.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
      };

      toggle.addEventListener('click', () => {
        toggle.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
      });

      overlay.addEventListener('click', closeMenu);
      nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { closeMenu(); toggle.focus(); return; }
        if (e.key !== 'Tab' || !nav.classList.contains('is-open')) return;
        const focusable = Array.from(nav.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])')).filter(el => !el.disabled);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviewsRoot = document.getElementById('reviews');
    if (reviewsRoot) {
      reviewsRoot.addEventListener('dragstart', (e) => {
        if (e.target && typeof e.target.closest === 'function' && e.target.closest('.review-card')) {
          e.preventDefault();
        }
      });
    }

    const el = document.querySelector('.reviews-scroll');
    if (!el) return;

    const isMobileScroll = () => window.matchMedia('(max-width: 1023px)').matches;

    let startX = 0;
    let scrollLeft = 0;
    let dragging = false;

    el.addEventListener('pointerdown', (e) => {
      if (!isMobileScroll()) return;
      dragging = true;
      startX = e.clientX;
      scrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
      el.setPointerCapture(e.pointerId);
    });

    el.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      el.scrollLeft = scrollLeft - (e.clientX - startX);
    });

    el.addEventListener('pointerup', () => {
      dragging = false;
      el.classList.remove('is-dragging');
    });

    el.addEventListener('pointercancel', () => {
      dragging = false;
      el.classList.remove('is-dragging');
    });

    el.addEventListener(
      'click',
      (e) => {
        if (!isMobileScroll()) return;
        if (Math.abs(el.scrollLeft - scrollLeft) > 5) e.preventDefault();
      },
      { capture: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  (() => {
    const timerContainer = document.querySelector('[data-countdown-timer]');
    if (!timerContainer) return;

    const valueNode = timerContainer.querySelector('[data-countdown-value]');
    if (!valueNode) return;

    const fallback = timerContainer.dataset.fallbackTimer || '24:00:00';
    const configuredHours = Number(timerContainer.dataset.countdownHours || '24');
    if (!Number.isFinite(configuredHours) || configuredHours <= 0) {
      valueNode.textContent = fallback;
      return;
    }

    let remainingSeconds = Math.floor(configuredHours * 60 * 60);

    const formatTime = (seconds) => {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    const render = () => {
      valueNode.textContent = formatTime(remainingSeconds);
    };

    render();

    const intervalId = setInterval(() => {
      if (remainingSeconds <= 0) {
        clearInterval(intervalId);
        return;
      }

      remainingSeconds -= 1;
      render();
    }, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
